import React from 'react'
import { NavLink } from 'react-router-dom'

export default function Header(){
  return (
    <nav className="navbar navbar-expand-lg navbar-light py-5">
      <a href="/" className="navbar-brand d-none d-lg-block" style={{position: 'absolute', left: '5px', top: '50%', transform: 'translateY(-50%)', zIndex: 1}}>
        <img src="/img/updatedlogo.jpeg" alt="Lakulish Pharmaceuticals Logo" style={{height: '140px', width: '220px'}} />
      </a>
      {/* <a className="navbar-brand d-block d-lg-none">
        <img src="/img/PARMA.jpg" style={{height: '95px', width: '156px', marginLeft: '53px', padding: '10px'}} alt="Logo" />
      </a> */}
      <a className="navbar-brand d-block d-lg-none">
        <h1 className="m-0 display-4 text-primary">Lakulish Pharmaceutical</h1>
      </a>
      <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
        <div className="navbar-nav mr-auto py-0" style={{paddingLeft: '220px'}}>
          <NavLink to="/" className="nav-item nav-link" end>Home</NavLink>
          <NavLink to="/about" className="nav-item nav-link">About Us</NavLink>
          <NavLink to="/research" className="nav-item nav-link">R&D / Technical</NavLink>
          <NavLink to="/infrastructure" className="nav-item nav-link">Infrastructure</NavLink>
          <NavLink to="/products" className="nav-item nav-link">Products</NavLink>
          <NavLink to="/contact" className="nav-item nav-link">Contact Us</NavLink>
        </div>
      </div>
    </nav>
  )
}
